import { React, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { jobRoleService } from "../../services/JobRoleService";
import HiredCandidatesGrid from "./HiredCandidatesGrid";
import "moment/locale/pt";
import "moment/locale/fr";
import "moment/locale/en-gb";
import { HiredCandidatesService } from "../../services/HiredCandidatesService";

import { useGeneralContext } from "../../pages/General/Context";

import SideDrawerSearch from "../../components/SideDrawerSearch";
import FilterForm from "./FilterForm";

export default function HiredCandidateFilter() {
  const { t } = useTranslation();
  const { userInformation } = useGeneralContext() || {};
  const [searchObject, setSearchObject] = useState({});

  const [pageSize, setPageSize] = useState(10);
  const [totalPages, SetTotalPages] = useState(0);
  const [pageNumber, setPageNumber] = useState(1);
  const [isDataLoading, setIsDataLoading] = useState(true);
  const [hiredCandidates, setHiredCandidates] = useState([]);
  const [filter, setFilter] = useState({});
  const [updateHiredCandidatesGrid, setUpdateHiredCandidateGrid] = useState(
    false
  );

  useEffect(() => {
    search(searchObject);
  }, []);

  useEffect(() => {
    search(searchObject);
  }, [pageNumber, pageSize, searchObject.orderBy, searchObject.order]);

  function search(_searchObject) {
    let _searchObject2 = { ..._searchObject };
    if (_searchObject2.businessAreas?.length > 0)
      _searchObject2.businessAreas = _searchObject2.businessAreas.map(
        (item) => item.id
      );
    HiredCandidatesService.getHiredCandidates(
      pageSize,
      pageNumber,
      _searchObject2
    )
      .then((result) => {
        setHiredCandidates(result.page);
        SetTotalPages(Math.ceil(result.total / pageSize));
      })
      .finally(() => {
        setIsDataLoading(false);
      });
  }

  const clearFilters = () => {
    setSearchObject({
      businessAreas: 0
    });

    search({});
  };

  const formatAllow = { excel: 0, pdf: 1 };

  const exportToExcel = (format) => {
    let fileName = "";
    if (format === formatAllow.excel) {
      fileName = `${userInformation.companyAbbreviation}_${t(
        "HiredCandidates"
      )}_${new Date().toLocaleDateString()}.xlsx`;
    } else {
      fileName = `${userInformation.companyAbbreviation}_${t(
        "HiredCandidates"
      )}_${new Date().toLocaleDateString()}.xlsx`;
    }

    let expectedResults = totalPages * pageSize;

    HiredCandidatesService.exportToexcel(
      searchObject,
      expectedResults,
      fileName,
      format
    );
  };
  function addFilter(filterName, filterValue) {
    setFilter({ ...filter, [filterName]: filterValue });
  }
  function searchForm() {
    return (
      <FilterForm
        searchObject={searchObject}
        setSearchObject={setSearchObject}
        addFilter={addFilter}
      />
    );
  }

  return (
    <>
      <div>
        <div className="d-flex row ms-2 me-2">
          <div className="col text-end export-position">
            {userInformation.permissions?.Hired_Candidates_Export && (
              <button
                type="button"
                id="exportPreCandidates"
                className="app-button btn-second btn-md field-filters-height"
                aria-expanded="false"
                onClick={() => {
                  exportToExcel(formatAllow.excel);
                }}
              >
                {t("Export")}
              </button>
            )}
          </div>
        </div>
      </div>

      <SideDrawerSearch
        searchForm={searchForm}
        onClearFilters={clearFilters}
        filterObject={filter}
        setFilterObject={setFilter}
        submitSearch={() => search(searchObject)}
      >
        <HiredCandidatesGrid
          hiredCandidatesList={hiredCandidates}
          setPageSize={setPageSize}
          pageNumber={pageNumber}
          setPageNumber={setPageNumber}
          totalPages={totalPages}
          isDataLoading={isDataLoading}
          updateHiredCandidatesGrid={updateHiredCandidatesGrid}
          setUpdateHiredCandidateGrid={setUpdateHiredCandidateGrid}
          setSearchObject={setSearchObject}
        />
      </SideDrawerSearch>
    </>
  );
}
